import React, { useEffect, useState, useCallback } from 'react';
import { debounce } from 'lodash';
import PropTypes from 'prop-types';
import CircularProgressbar from 'react-circular-progressbar';
import classNames from 'classnames';
import 'react-circular-progressbar/dist/styles.css';
import { Checkmark } from './icons';
import './ProgressIcon.css';

function ProgressIcon(props) {
  const [progress, setProgress] = useState(0);
  const { percentage, colorScheme, imgSrc } = props;

  const className = classNames('progress-icon', {
    'progress-icon--red': colorScheme === 'red',
    'progress-icon--green': colorScheme === 'green',
    'progress-icon--blue': colorScheme === 'blue',
    'progress-icon--empty': percentage === 0
  });

  const debouncedProgress = useCallback(
    debounce(() => setProgress(percentage), 250, { trailing: true }),
    [percentage]
  );

  useEffect(() => {
    debouncedProgress();
    return () => debouncedProgress.cancel();
  }, [debouncedProgress]);

  return (
    <div className={className}>
      <img
        width="118px"
        height="118px"
        className="progress-icon__image"
        alt=""
        src={imgSrc}
      />
      <CircularProgressbar
        strokeWidth={5}
        percentage={progress}
        textForPercentage={null}
      />
      {percentage === 100 && (
        <div className="progress-icon__checkmark">
          <Checkmark />
        </div>
      )}
    </div>
  );
}

ProgressIcon.propTypes = {
  percentage: PropTypes.number,
  colorScheme: PropTypes.oneOf(['red', 'green', 'blue']),
  imgSrc: PropTypes.string.isRequired
};

ProgressIcon.defaultProps = {
  percentage: 0,
  colorScheme: 'red'
};

export default React.memo(ProgressIcon);



// WEBPACK FOOTER //
// ./src/components/ProgressIcon.js